import { finalize } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ComponentsService, ContainerCardComponent, FormBuilderModule, FormEnum, FormHandlerService, UserDTO } from 'library-explorer';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
  standalone: true,
  imports: [ContainerCardComponent, CommonModule, FormBuilderModule, FormsModule]
})
export class VerifyEmailComponent  implements OnInit {

  formData = {
    email: {
      value: '',
      required: true,
    }
  };

  formContent = {
    button: FormEnum.Button
  }

  isLoading: boolean = false;

  constructor(
    private formHandlerService: FormHandlerService,
    private components: ComponentsService,
    private authService: AuthenticationService,
    private modalCtrl: ModalController,
    private utilities: UtilitiesService,
    private router: Router
  ) { }

  ngOnInit() {}

  dismissModal(data?: any) {
    this.modalCtrl.dismiss(data ?? '', 'verify your email');
  }

  processForm() {
    const user = this.authService.authUserValue;
    if (!user) return;

    this.formData.email.value = user.email;

    const validatedFormData = this.formHandlerService.validateForm(this.formData);
    if (!validatedFormData) return;

    this.isLoading = true;
    this.authService.requestOtp(validatedFormData)
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe(() => {
        let returnUrl = this.router.url;
        this.components.presentToast('Kindly verify your email!', 'success');
        this.dismissModal({ success: true })

        this.router.navigate(['verification'], {
          queryParams: { returnUrl }
        });
      });
    return;
  }
}
